export default {"src":"/_next/static/media/actn.17d57ae8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};